import {
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { sort } from "d3-array";
import React, { Component } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import ExpectedAcvPage from "../NewWaterFall/ExpectedAcvPage";
import {
  customDateFormatterNew,
  getDefaultSelectedFiscalQuarters,
} from "../../util/customFunctions";
// import addHeaderdescription from "../../components/HeaderDescription";
import DataTable from "./DataTable";
import Drilldown from "../../components/Drilldown/DrilldownWithSLD";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import DealRegistrationTable from "./DealsRegistrationTable";
import DrilldownTorq from "../../RepPerformance/GenericScorecard/DrilldownTorq";

const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
  },
  tableClickable: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
    cursor: "pointer",
  },
  rep: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    width: "20%",
    color: "inherit",
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    width: "20%",
    color: "inherit",
  },
  mainTable: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 1000,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1400,
    },
  },
  mainTable2: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 800,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1200,
    },
  },
});
class POcsSummary extends Component {
  state = {
    Internal_Torq_Record__c: ["False"],
    Exclude_Deal_Reg_Status__c: ["All"],
    location: null,
    secondLevelLocation: null,
    toggleValue: "Acv",
    showWeeklyAvg: false,
    header: "POCs Summary",
  };
  componentDidMount = () => {
    this.props.getfunnelCompareFilters();
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.funnelCompareFilters !== "" &&
      prevProps.funnelCompareFilters === ""
    ) {
      
  let dfi = 'False'
    if(this.props.funnelCompareFilters.defaultInternal_Torq_Record__c.length > 0){
        dfi = this.props.funnelCompareFilters.defaultInternal_Torq_Record__c
    }

    let dealdefault = ['All']

  if(this.props.funnelCompareFilters.deaultDeal_Reg_Status__c.length > 0){
        dealdefault = this.props.funnelCompareFilters.deaultDeal_Reg_Status__c
    }

      this.setState({
        ...this.state,
      Internal_Torq_Record__c: dfi,
      Exclude_Deal_Reg_Status__c: dealdefault,
      });
    }
  }

  handleChangeToggle = (e) => {
    this.setState({
      ...this.state,
      toggleValue: e.target.value,
    });
  };

  handleChange = (e) => {
    this.setState({ ...this.state, [e.target.name]: e.target.value });
  };

  handleChangeNew = (e) => {
    if (
      e.target.name === "closed_year" &&
      e.target.value.filter((v) => v === "All").length > 0
    ) {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        closed_month: ["All"],
        quarter: ["All"],
      });
    } else if (typeof e.target.value === "string") {
      this.setState({
        ...this.state,
        [e.target.name]: [e.target.value],
      });
    } else {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
      });
    }
  };

  setFromDate = (date) => {
    const split = this.state.to.split("-");
    const toDate = new Date(
      parseInt(split[2]),
      parseInt(split[0]) - 1,
      parseInt(split[1])
    );
    if (new Date(date) > toDate) {
      this.setState({
        ...this.state,
        from: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "From date cannot be later than the To date",
      });
    } else {
      this.setState({
        ...this.state,
        from: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "",
        errorTextTo: "",
      });
    }
  };

  setToDate = (date) => {
    const split = this.state.from.split("-");
    const fromDate = new Date(
      parseInt(split[2]),
      parseInt(split[0]) - 1,
      parseInt(split[1])
    );
    if (new Date(date) < fromDate) {
      this.setState({
        ...this.state,
        to: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "To date cannot be earlier than the From date",
      });
    } else {
      this.setState({
        ...this.state,
        to: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextTo: "",
        errorTextFrom: "",
      });
    }
  };

  handleGo = () => {
    localStorage.removeItem("skygeni-auto-update");
    var filters = [];

    if (this.state.Internal_Torq_Record__c[0] !== "All") {
      const obj = {
        name: "Internal_Torq_Record__c",
        value:
          typeof this.state.Internal_Torq_Record__c === "string"
            ? [this.state.Internal_Torq_Record__c]
            : this.state.Internal_Torq_Record__c,
      };
      filters = [...filters, obj];
    }

    if (this.state.Exclude_Deal_Reg_Status__c[0] !== "All") {
      const obj = {
        name: "Exclude_Deal_Reg_Status__c",
        value:
          typeof this.state.Exclude_Deal_Reg_Status__c === "string"
            ? [this.state.Exclude_Deal_Reg_Status__c]
            : this.state.Exclude_Deal_Reg_Status__c,
      };
      filters = [...filters, obj];
    }

    this.setState({ ...this.state });
    this.props.getCallsCompletedData(filters);
  };

  handleChangeLocationBack = (location) => {
    this.setState({
      ...this.state,
      location: location,
      secondLevelLocation: location,
    });
    //this.props.setTable('')
  };
  handleChangeLocation = (location, isContact, header, quarter, month) => {
    if (location !== "overview") {
      let filters = [];
      let drildownFilters = [];

      if (this.state.Internal_Torq_Record__c[0] !== "All") {
      const obj = {
        name: "Internal_Torq_Record__c",
        value:
          typeof this.state.Internal_Torq_Record__c === "string"
            ? [this.state.Internal_Torq_Record__c]
            : this.state.Internal_Torq_Record__c,
      };
      filters = [...filters, obj];

        drildownFilters = [
        ...drildownFilters,
        {
          title: "Internal Torq Record",
          value:
          typeof this.state.Internal_Torq_Record__c === "string"
            ? [this.state.Internal_Torq_Record__c]
            : this.state.Internal_Torq_Record__c,
        },
      ];
    }

    if (this.state.Exclude_Deal_Reg_Status__c[0] !== "All") {
      const obj = {
        name: "Exclude_Deal_Reg_Status__c",
        value:
          typeof this.state.Exclude_Deal_Reg_Status__c === "string"
            ? [this.state.Exclude_Deal_Reg_Status__c]
            : this.state.Exclude_Deal_Reg_Status__c,
      };
      filters = [...filters, obj];
       drildownFilters = [
        ...drildownFilters,
        {
          title: "Deal Reg. Status Excluded",
          value:
          typeof this.state.Exclude_Deal_Reg_Status__c === "string"
            ? [this.state.Exclude_Deal_Reg_Status__c]
            : this.state.Exclude_Deal_Reg_Status__c,
        },
      ];
    }

    

      if (month) {
        const obj = {
          name: "month",
          value: typeof month === "string" ? [month] : month,
        };
        filters = [...filters, obj];

          drildownFilters = [
        ...drildownFilters,
        {
          title: "Month",
          value: typeof month === "string" ? [month] : month,
        },
      ];
      }

      if (quarter) {
       

          drildownFilters = [
        ...drildownFilters,
        {
          title: "Fiscal Quarter",
          value: typeof quarter === "string" ? [quarter] : quarter,
        },
      ];
      }

      filters = [...filters];

    

      this.setState({
        ...this.state,
        location: location,
        secondLevelLocation: location,
        // header:key1 === 'Won' ? 'Won' : key1 === 'Open' ? `Open Pipeline (${this.state.Stage[0]} or later)` : `Lost or Disqualified (${this.state.Stage[0]} or later)`,
        filtersForDrilldown: [...drildownFilters],
        header: header,
      });

      if(isContact){
        this.props.getContactDrilldownData(filters)
      }else{

        this.props.getCallsCompletedDrilldownData(filters);
      }
    } else {
      this.props.clearDrilldownData();
    }
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      // location: location,
      secondLevelLocation: location,
    });
    this.props.getOpenOppData(oppId);
  };

  stepBack = () => {
    this.setState({
      ...this.state,
      secondLevelLocation: "",
    });
    this.props.clearExpectedAcvData();
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container>
        {/* {addHeaderdescription(
          "POCs Summary",
          "Examine POCs started and ended over time"
        )} */}
        <AddHeaderDescriptionWithHelperText
          header={`Deal Registrations Scorecard (Torq)`}
          description={`Analyze deal registration trends.`}
          helperTextCharts={this.props.helperTextCharts}
        />

        {this.props.funnelCompareFilters !== "" ? (
          <Grid item container xs={12}>
            <Grid container item style={{ padding: 10 }} xs={2} md={2}>
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                justify="space-around"
              >
                <Grid item xs={12} style={{ paddingTop: 10 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-fiscalQuarter-label"
                      style={{
                      color: "#4472c4"
                      }}
                    >
                     Internal Torq Record:
                    </InputLabel>
                    <Select
                      data-test="Internal_Torq_Record__c"
                      labelId="select-fiscalQuarter-label"
                      id="select-fiscalQuarter"
                      value={this.state.Internal_Torq_Record__c}
                      onChange={this.handleChange}
                      label="Earliest Start Quarter"
                      name="Internal_Torq_Record__c"
                    >
                      {this.props.funnelCompareFilters !== "" &&
                        this.props.funnelCompareFilters.Internal_Torq_Record__c.filter(
                          (item) => item.Internal_Torq_Record__c !== ""
                        ).map((y) => (
                          <MenuItem
                            key={y.Label}
                            value={y.Label}
                          >
                            {y.Label}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>


             <Grid container item style={{ padding: 10 }} xs={2} md={2}>
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                justify="space-around"
              >
                <Grid item xs={12} style={{ paddingTop: 10 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-fExclude_Deal_Reg_Status__c-label"
                      style={{
                        color: !this.state.Exclude_Deal_Reg_Status__c.includes(
                          "All"
                        )
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Deal Reg. Status Excluded:
                    </InputLabel>
                    <Select
                      data-test="Exclude_Deal_Reg_Status__c"
                      labelId="select-Exclude_Deal_Reg_Status__c-label"
                      id="select-Exclude_Deal_Reg_Status__c"
                      value={this.state.Exclude_Deal_Reg_Status__c}
                      onChange={this.handleChangeNew}
                      label="Deal Reg. Status Excluded:"
                      name="Exclude_Deal_Reg_Status__c"
                      multiple
                    >
                         <MenuItem value={"All"}>None</MenuItem>
                      {this.props.funnelCompareFilters !== "" &&
                        this.props.funnelCompareFilters.Deal_Reg_Status__c.filter(
                          (item) => item.Deal_Reg_Status__c !== ""
                        ).map((y) => (
                          <MenuItem
                            key={y.Deal_Reg_Status__c}
                            value={y.Deal_Reg_Status__c}
                          >
                            {y.Deal_Reg_Status__c}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              sm={1}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                data-test="go"
                variant="contained"
                color="primary"
                onClick={this.handleGo}
              >
                GO
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Card style={{ margin: "auto", width: "100%" }} raised={true}>
            <Grid item container justify="center">
              <Skeleton
                variant="react"
                animation="wave"
                height={20}
                width="90%"
                style={{ margin: "1rem" }}
              />
            </Grid>
          </Card>
        )}

        {/* <Grid item xs={12} style={{ padding: "1rem", paddingLeft: 0 }}>
          {this.props.CallsCompletedData !== "" ? (
            this.props.CallsCompletedData.data.map(({title, monthData, quarterData, uniqueMonths, uniqueQuarters}, idx) => 
            <Grid item container xs={12} justify="flex-start">
              <Card style={{ padding: "1rem 2rem" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                      }}
                      align="center"
                    >
                      {title}
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                <DealRegistrationTable
                  data={monthData}
                  quarterData={quarterData}
                  // dataTotal={this.props.CallsCompletedData.totalData}
                  uniqueQuarters={uniqueQuarters}
                  uniqueMonths={uniqueMonths}
                  handleChangeLocation={this.handleChangeLocation}
                  dataTest={`${title}-test`}
                />
              </Card>
            </Grid>
            )
            
          ) : (
            <Grid item container component={Card} justify="center">
              <Skeleton
                animation="wave"
                variant="rect"
                width="80%"
                height={200}
                style={{ margin: "20px 0px" }}
              />
            </Grid>
          )}
        </Grid> */}

        <Grid item xs={12} style={{ padding: "1rem", paddingLeft: 0 }}>
  {this.props.CallsCompletedData !== "" ? (
    this.props.CallsCompletedData.data.map(({title, monthData, quarterData, uniqueMonths, uniqueQuarters, isContact}, idx) => (
      <Grid 
        item 
        xs={12} 
        key={idx}
        style={{ 
          marginBottom: "2rem", // Spacing between cards
          width: "100%" 
        }}
      >
        <Card 
          style={{ 
            padding: "1rem 2rem",
            width: "100%", // Full width card
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional: better shadow
          }}
        >
          {/* Title Section */}
          <Grid container justifyContent="center" style={{ marginBottom: "1rem" }}>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                style={{
                  width: "100%",
                  margin: "auto",
                  padding: "1rem",
                  paddingTop: "0.3rem",
                  textAlign: "center", // Center align title
                }}
              >
                {title}
              </Typography>
            </Grid>
          </Grid>

          {/* Table Section - Centered */}
          <Grid container justifyContent="center">
            <Grid item style={{ width: "100%" }}>
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                width: "100%" 
              }}>
                <DealRegistrationTable
                  data={monthData}
                  monthData={monthData}
                  quarterData={quarterData}
                  uniqueQuarters={uniqueQuarters}
                  uniqueMonths={uniqueMonths}
                  handleChangeLocation={this.handleChangeLocation}
                  dataTest={`${title}-test`}
                  header={title}
                  isContact={isContact}
                />
              </div>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    ))
  ) : (
    <Grid item container component={Card} justify="center">
      <Skeleton
        animation="wave"
        variant="rect"
        width="80%"
        height={200}
        style={{ margin: "20px 0px" }}
      />
    </Grid>
  )}
</Grid>
       

        {this.state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={this.state.header}
              back={this.handleChangeLocationBack}
              filters={this.state.filtersForDrilldown}
            >
              <DrilldownTorq
                header={this.state.header}
                body={this.props.CallsCompletedDrilldownData}
                // handleSecondLevelDrilldown={this.handleSecondLevelDrilldown}
              />
              {/* <Drilldown body={this.props.CallsCompletedDrilldownData} isMetaData={this.state.isMetaData} metaData={this.state.metaData} drilldownLabelString={this.state.drilldownLabelString} 
                 company={this.props.company} 
                handleSecondLevelDrilldown={this.handleSecondLevelDrilldown}
                 />   */}
            </SingleLevelDrilldown>
          </Grid>
        )}
        {/* {this.state.secondLevelLocation === "drilldownOppId" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={"Opportunity Change Events"}
              back={this.handleChangeLocationBack}
              stepBack={this.stepBack}
              filters={[]}
            >
              <ExpectedAcvPage body={this.props.ExpectedAcvData} />
            </SingleLevelDrilldown>
          </Grid>
        )} */}
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  var {
    user,
    POCSSummaryData,
    drilldownOnGraphData,
    ExpectedAcvData,
    POCSSummaryFilters,
    currentFilters,
  } = state.app;

  return {
    company: user.company,
    CallsCompletedData: POCSSummaryData,
    CallsCompletedDrilldownData: drilldownOnGraphData,
    funnelCompareFilters: POCSSummaryFilters,
    ExpectedAcvData,
    currentFilters,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};
const mapDispatchToProps = (dispatch) => ({
  clearDrilldownData: () => {
    dispatch({ type: "clear_POCSSummary_drilldown_data" });
  },
  getfunnelCompareFilters: (company) => {
    dispatch({ type: "get_POCSSummary_filters_request" });
    appService.getDealRegsitrationPocsSummaryFilters().then(
      (json) => {
        dispatch({ type: "get_POCSSummary_filters_success", json });
        dispatch({ type: "get_POCSSummary_data_request" });
         const defaultInternalTorq = json.message.defaultInternal_Torq_Record__c
         const excludeDealRegStatus = json.message.deaultDeal_Reg_Status__c
     
        let filters = [];
        if(defaultInternalTorq.length > 0){
            filters = [
                ...filters,
                { name: "Internal_Torq_Record__c", value: defaultInternalTorq },
              ];
        }

        if(excludeDealRegStatus.length > 0){
          filters = [
                ...filters,
                { name: "Exclude_Deal_Reg_Status__c", value: excludeDealRegStatus },
              ];
        }
   
        dispatch({ type: "current_selected_filters", filters });
        appService.getDealRegsitrationPocsSummaryData(filters).then(
          (json) => {
            dispatch({ type: "get_POCSSummary_data_success", json });
          },
          (error) => {
            if (typeof error === "object")
              dispatch({
                type: "get_POCSSummary_data_failure",
                error: "Something went wrong",
              });
            else dispatch({ type: "get_POCSSummary_data_failure", error });
          }
        );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_POCSSummary_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_POCSSummary_filters_failure", error });
      }
    );
  },
  getCallsCompletedDrilldownData: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getDealRegsitrationPocsSummaryDrilldown(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) =>
          a.acvAtStage > b.acvAtStage ? -1 : 1
        );
        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            ...json.message,
            columns: json.message.columns,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
          },
        };

        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
   getContactDrilldownData: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getDealRegsitrationContactPocsSummaryDrilldown(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) =>
          a.acvAtStage > b.acvAtStage ? -1 : 1
        );
        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            ...json.message,
            columns: json.message.columns,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
          },
        };

        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  getCallsCompletedData: (filters) => {
    dispatch({ type: "get_POCSSummary_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getDealRegsitrationPocsSummaryData(filters).then(
      (json) => {
        dispatch({ type: "get_POCSSummary_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_POCSSummary_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_POCSSummary_data_failure", error });
      }
    );
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});
const connectedDealRegistarationPOcsSummary = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(POcsSummary));
export default connectedDealRegistarationPOcsSummary;
